import React, { Fragment, useState, } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import { Box, Icon, Columns, Column, Button, Control, Field } from 'Components/common/bulma'
import { Table, ModalRemove } from 'Components/common'
import {
  getInventory,
  getUniqueProducts,
  updateFilters,
  removeInventory,
} from 'Modules/inventory'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'
import { Trans } from '@lingui/macro'
import {
  unexpectedStockOutflowList,
  filter,
} from './data'
import { addNotification } from 'Modules/principal'
import { Date as DatePicker } from 'Components/common/form'
import { SelectWithError } from 'Components/common/form/index'
import { validateData, getValues, getDataInput } from 'App/helpers'
import { propEq } from 'ramda'
import moment from 'moment'
import useUnexpectedStockOutflowList from './useUnexpectedStockOutflowList'
import useNotification from 'Hooks/useNotification'

const ListaContainer = (props) => {
  const { products, unexpectedStocks, refreshUnexpectedStockOutflowByProduct } = useUnexpectedStockOutflowList()
  const [selectedProduct, setSelectedProduct] = useState(undefined)
  const [showModal, setShowModal] = useState(false)
  const [inventory, setInventory] = useState({})
  const [data, setData] = useState(filter)
  const [minDate, setMinDate] = useState(undefined)
  const [maxDate, setMaxDate] = useState(undefined)
  const [showErrors, setShowErrors] = useState(false)
  const { addNotification, NotificationUI } = useNotification()
  const onEdit = ({ id }) => {
    props.push(`/inventarios/salidas-extraordinarias/${id}`)
  }
  const updateDateLimits = ({ value }) => {
    const product = props.uniqueProducts.find(propEq('producto', value))

    if (!product) {
      return false
    }
    setMinDate(moment(product.fechas.inicio).toDate())
    setMaxDate(moment(product.fechas.final).toDate())
  }

  const filterData = async (params) => {
    const { product, fechaInicio, fechaFin } = data
    const { data: validatedData, hasErrors } = validateData(data)

    if (hasErrors) {
      setData(validatedData)
      setShowErrors(true)
      return new Promise((resolve) => resolve(true))
    }

    const values = getValues(data)
    const filters = {
      product: product.value,
      fechaInicio: fechaInicio.value,
      fechaFin: fechaFin.value
    }

    props.updateFilters(filters)
    try {
      await refreshUnexpectedStockOutflowByProduct({
        ...params,
        ...values
      })
    } catch (error) {
      console.log(error)
      addNotification({ message: error.message, type: 'danger' })
    }
  }

  const onChangeInput = ({ target }) => {
    const { name } = target
    const newData = getDataInput(target, data)
    const field = newData[name]

    setData(newData)
    setShowErrors(false)

    // if (field.trigger) {
    //   const triggerFunction = { updateDateLimits }[field.trigger]
    //   if (triggerFunction) {
    //     triggerFunction(field)
    //   }
    // }
  }

  const toggleModal = inventoryItem => {
    setShowModal(!showModal)
    setInventory(inventoryItem)
  }


  const customColAccions = row => (
    <Fragment>
      <Button small className="margin-left-xs" primary outlined onClick={() => onEdit(row)}>
        <Icon>
          <FontAwesomeIcon icon={faEdit} />
        </Icon>
      </Button>
    </Fragment>
  )

  const {
    permissions,
  } = props

  const {
    product,
    fechaFin,
    fechaInicio,
  } = data

  return (
    <Box>
      <NotificationUI />
      <ModalRemove
        isDeleting={showModal}
        title="Eliminar inventario"
        toggleModal={toggleModal}
        confirmText="¿Esta seguro de querer eliminar el inventario?"
        resource={inventory.id}
        deleteResource={() => {}}
      />
      <Columns>
        <Column>
          <Link className="button is-success is-outlined is-pulled-right" to="/inventarios/salidas-extraordinarias/nuevo">
            <Icon>
              <FontAwesomeIcon icon={faPlus} />
            </Icon>
            <Trans render="span">Agregar</Trans>
          </Link>
        </Column>
      </Columns>
      <Columns>
        <Column>
          <SelectWithError
            options={ products }
            {...product}
            input={{
              value: product.value,
              name: 'product',
            }}
            onChange={onChangeInput}
            showErrors={showErrors}
          />
        </Column>
        <Column>
          <DatePicker
            {...fechaInicio}
            onChange={onChangeInput}
            minDate={minDate}
            maxDate={maxDate}
            openToDate={minDate}
          />
        </Column>
        <Column>
          <DatePicker
            {...fechaFin}
            onChange={onChangeInput}
            minDate={minDate}
            maxDate={maxDate}
            openToDate={maxDate}
          />
        </Column>
        <Column>
        <Field>
          <label className="label">&nbsp;</label>
          <Control>
          <Button primary outlined
            onClick={filterData}
          >Buscar</Button>
          </Control>
        </Field>
        </Column>
      </Columns>
      <Columns>
        <Column className="is-full">
          <Table
            initialFetch={false}
            colsetup={unexpectedStockOutflowList}
            coldata={{data: unexpectedStocks}}
            tableClassName='table is-striped is-hoverable is-fullwidth'
            emptyTableMarkUp={<span>No hay registros</span>}
            customCol={{
              customColName: 'actions',
              renderFunc: customColAccions
            }}
            refresh={refreshUnexpectedStockOutflowByProduct}
          />
        </Column>
      </Columns>
    </Box>
  )
}

const mapStateToProps = ({ principal, inventory: { uniqueProducts, inventory, filters } }) => ({
  uniqueProducts,
  inventory,
  permissions: principal.inventoryPermission,
  filters,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getInventory,
  getUniqueProducts,
  push,
  addNotification,
  updateFilters,
  removeInventory
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ListaContainer)